import {values} from './ClientLocatorData';


/**
 * Returns an object with Client Locator validation default values.
 * @param {string} accountName client account name 
 * @returns {object} 
 */
export function getDefaultValues(accountName){
    const key = accountName.toLowerCase();
    return values[key]? values[key] : values['default'];
}

/**
 * Returns validator for Client Locator field.
 * 
 * @param {string} accountName client account name.
 * @returns {object} the validator.
 */
export function getValidator(accountName) {
    const key = accountName.toLowerCase();
    let validator = null;
    try {
        validator = require('./ClientLocator.' + key);
    } catch (error) {
        validator = require('./ClientLocator.default');
    }
        
    return validator;
}


// WEBPACK FOOTER //
// ./src/components/Reservation/Validators/ClientLocatorFactory.js